import { categorizeFirestoreError } from './firebaseErrors';

/** Thai user-facing copy for dashboard / reporting table load failures. */
export const reportingDashboardErrorMessage = (error: unknown): string => {
  const category = categorizeFirestoreError(error);
  if (category === 'permission-denied') {
    return 'คุณไม่มีสิทธิ์ดูข้อมูลรายงานนี้ กรุณาติดต่อผู้ดูแลเพื่อขอสิทธิ์';
  }
  if (category === 'network') {
    return 'ไม่สามารถโหลดข้อมูลได้ (เครือข่ายขัดข้อง) ลองใหม่อีกครั้ง';
  }
  return 'ไม่สามารถโหลดข้อมูลแดชบอร์ดได้ กรุณาลองใหม่';
};
